import logoRaw from '@/assets/small-logo.svg?raw'
import styles from './Loader.module.scss'

interface LoaderProps {
  className?: string
  testId?: string
}

export const Loader = ({ className, testId = 'loader' }: LoaderProps) => {
  const containerClass = [styles.container, className].filter(Boolean).join(' ')

  return (
    <div className={containerClass} data-testid={testId}>
      <div className={styles.wrapper}>
        <div className={styles.spinner} data-testid={`${testId}-spinner`} />
        <span
          className={styles.logo}
          dangerouslySetInnerHTML={{ __html: logoRaw }}
        />
      </div>
    </div>
  )
}
